module.exports = __webpack_public_path__ + "static/media/time_alert.8736d8b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icon/time_alert.svg
// module id = 477
// module chunks = 0